import { ProductManualRecommendationEntity } from '@product/const/v2';
import { StateUtils } from '@spartacus/core';
import { PRODUCT_MANUAL_RECOMMENDATION_ENTITY } from '../product-recommendations-state';

export const LOAD_PRODUCT_MANUAL_RECOMMENDATION = '[Product-manual-recommendation] Product-manual-recommendation Load';
export const LOAD_PRODUCT_MANUAL_RECOMMENDATION_FAIL =
  '[Product-manual-recommendation] Product-manual-recommendation Load Fail';
export const LOAD_PRODUCT_MANUAL_RECOMMENDATION_SUCCESS =
  '[Product-manual-recommendation] Product-manual-recommendation Load Success';

export class ProductManualRecommendationLoad extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_PRODUCT_MANUAL_RECOMMENDATION;

  constructor(public payload: string) {
    super(PRODUCT_MANUAL_RECOMMENDATION_ENTITY);
  }
}

export class ProductManualRecommendationLoadFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_PRODUCT_MANUAL_RECOMMENDATION_FAIL;

  constructor(public payload: any) {
    super(PRODUCT_MANUAL_RECOMMENDATION_ENTITY, payload);
  }
}

export class ProductManualRecommendationLoadSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_PRODUCT_MANUAL_RECOMMENDATION_SUCCESS;

  constructor(public payload: ProductManualRecommendationEntity | null) {
    super(PRODUCT_MANUAL_RECOMMENDATION_ENTITY);
  }
}

export type ProductManualRecommendationLoadAction =
  | ProductManualRecommendationLoad
  | ProductManualRecommendationLoadFail
  | ProductManualRecommendationLoadSuccess;
